// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__2g-MA","nextBtn":"Navigation_nextBtn__2BUiE"};